<template>
  <div class="dd-member">
    <avatar :person="person" :size="avatarSize" />
    <div class="dd-member__text">
      <span class="dd-member__text-name">
        {{ person.name }} <span v-if="isCurrentUser">(You)</span>
        <span v-if="title" class="dd-member__text-title">({{ title }})</span>
      </span>
      <span v-if="company" class="dd-member__text-company">{{ company }}</span>
    </div>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */
import PersonAvatar from '@/components/global/avatar.vue'
import { IPersonBase } from '@/api/types/response.types'

/* Helpers */

/* Data types */

/* API */

/**
 * DdMember component displays user/company information
 * such as its avatar image (DdAvatar) and name/company/description.
 */
export default defineComponent({
  name: 'DdMember',

  components: {
    PersonAvatar,
  },

  props: {
    person: {
      type: Object as () => IPersonBase,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    company: {
      type: String,
      default: '',
    },
    isCurrentUser: {
      type: Boolean,
      default: false,
    },
    avatarSize: {
      type: Number,
      default: 24,
    },
  },
})
</script>

<style lang="scss">
.dd-member {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border: none;

  &__text {
    flex: 1;
    padding-left: 12px;

    &-name {
      @include lettering--p;
    }
    &-title {
      margin-left: 5px;
    }

    &-company {
      display: block;
      @include lettering--p-sm;
      color: var(--color-text-primary);
    }
  }
}
</style>
